export default {"src":"/_next/static/media/training_s.d1d703ee.svg","height":31,"width":30,"blurWidth":0,"blurHeight":0};